import { sampleTrace, type PresentationEvent, type PresentationFrame, type PresentationTrace } from "../core";
import type { PresentationSource } from "./types";

export class TraceSource implements PresentationSource {
  readonly mode = "trace" as const;
  readonly canSeek = true;
  private currentTime = 0;

  constructor(readonly trace: PresentationTrace) {}

  get id(): string { return traceId(this.trace); }
  get title(): string { return this.trace.title; }
  get time(): number { return this.currentTime; }
  get duration(): number { return this.trace.duration; }
  get events(): readonly PresentationEvent[] { return this.trace.events; }
  get sourceLabel(): string { return this.trace.source; }

  reset(): void {
    this.currentTime = 0;
  }

  step(deltaSeconds: number): void {
    this.currentTime += Math.max(0, deltaSeconds);
    if (this.currentTime > this.duration) this.currentTime = 0;
  }

  seek(time: number): void {
    this.currentTime = Math.max(0, Math.min(this.duration, time));
  }

  sample(): PresentationFrame {
    return sampleTrace(this.trace, this.currentTime);
  }
}

function traceId(trace: PresentationTrace): string {
  return `trace:${trace.id}`;
}

